/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBloodNegative = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M15 15H9v-2h6z" />
        <path
          clipRule="evenodd"
          d="M12 1s8 7 8 13.363C20 18.581 16.418 22 12 22s-8-3.42-8-7.637C4 8 12 1 12 1zm0 2.776a34.208 34.208 0 0 0-2.428 2.755C7.61 9.028 6 11.904 6 14.363 6 17.39 8.598 20 12 20s6-2.61 6-5.637c0-2.459-1.61-5.335-3.572-7.832A34.203 34.203 0 0 0 12 3.776z"
          fillRule="evenodd"
        />
      </g>
    </g>
  </Icon>
);
export { SvgBloodNegative as BloodNegative };
